import React from 'react';
import VehicleDataset from "./vehicle-dataset.jsx";
import DayDataset from "./day-dataset.jsx";
import AverageDataset from "./average-dataset.jsx";
import AmountDataset from "./amount-dataset.jsx";
import TableLegend from "./table-legend.jsx";

const ReportContent = ({ data }) => {
    if (!data) return null;

    return (
        <>
            <div id="traffic-flow">
                <VehicleDataset data={data}/>

                <DayDataset data={data}/>

                <AverageDataset data={data}/>

                <AmountDataset data={data}/>

                <TableLegend data={"* Os totais podem apresentar divergência em relação ao SentryView devido às passagens com mais de uma classificação."}/>
            </div>


            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;